import { createUseStyles } from 'react-jss';

import { ITheme } from '../../../../styles';

const useStyles = createUseStyles(
  ({ breakpoints }: ITheme) => ({
    iconMenu: {
      cursor: 'pointer',
      marginInlineEnd: 20,
    },

    icon: {
      height: 24,
      width: 24,
      fill: '#000',
    },

    root: {
      backgroundColor: 'rgba(40, 43, 54, 0.40)',
      display: 'none',
      height: '100vh',
      left: 0,
      position: 'fixed',
      top: 0,
      width: '100vw',
      zIndex: 1000,
    },

    visible: {
      display: 'block',
    },

    submenu: {
      backgroundColor: '#fff',
      height: '100%',
      paddingInline: 24,
      position: 'absolute',
      left: '-100%',
      top: 0,
      transition: 'left .5s ease-in-out',
      width: 'min(100%, 302px)',
    },

    submenuVisible: {
      left: 0,
    },

    search: {},

    thirdLevel: {
      '& .NavBodyBottomLinks': {
        paddingInlineStart: 8,
      },
    },
  }),
  { name: 'MobileNav' },
);

export default useStyles;
